import { __awaiter, __generator } from "tslib";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Input } from "../withEmail/withEmail.styles";
import { useState } from "react";
import { useLoadingActions } from "../../../context&providers/providers/Loading";
import { StatusCodes } from "../../../utils/enums/StatusCode";
import { verifyOtp } from "../../../services/api/OnboardingServices";
import ResendOtp from "../resendOtp";
var VerifyOtp = function (_a) {
    var setStep = _a.setStep, email = _a.email;
    var _b = useState(''), otp = _b[0], setOtp = _b[1];
    var _c = useState(false), validOtp = _c[0], setValidOtp = _c[1]; // Track OTP validity
    var _d = useState(''), statusMessage = _d[0], setStatusMessage = _d[1];
    var _e = useLoadingActions(), showLoading = _e.showLoading, hideLoading = _e.hideLoading;
    var handleOtpSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var res, statusCode, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(otp.length === 6)) return [3 /*break*/, 5];
                    showLoading();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, verifyOtp(email, otp)];
                case 2:
                    res = _a.sent();
                    hideLoading();
                    statusCode = res.data.statusCode;
                    if (statusCode === StatusCodes.OTP_VERIFY_SUCCESS) {
                        setStatusMessage('OTP verified successfully!');
                        setStep(4); // Proceed to the next step (complete profile or home page)
                        window.location.href = "/";
                    }
                    else {
                        setStatusMessage('Invalid OTP. Please try again.');
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    hideLoading();
                    setStatusMessage('An error occurred. Please try again later.');
                    console.error(error_1);
                    return [3 /*break*/, 4];
                case 4: return [3 /*break*/, 6];
                case 5:
                    setStatusMessage('Please enter a valid 6-digit OTP.');
                    _a.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var handleOtpChange = function (e) {
        setOtp(e.target.value);
        setValidOtp(e.target.value.length === 6); // Validate OTP length
    };
    return (_jsxs(_Fragment, { children: [_jsx(Input, { type: "text", placeholder: "Enter OTP", value: otp, onChange: handleOtpChange }), statusMessage && _jsx("p", { children: statusMessage }), _jsx(Button, { onClick: handleOtpSubmit, disabled: !validOtp, children: "Verify OTP" }), _jsx(ResendOtp, { email: email })] }));
};
export default VerifyOtp;
